import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DashboardWrapper from "../../components/DashboardWrapper";
import userManageService from "../../services/userManageService"; // updated

export default function CreateCustomer() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone_number: "",
    password: "",
    password_confirmation: "",
  });

  const [loading, setLoading] = useState(false);

  // State for toggling password visibility
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await userManageService.createCustomer(formData);
      Swal.fire({
        icon: "success",
        title: "Customer Created",
        text: "The customer has been created successfully.",
        confirmButtonText: "OK",
        customClass: { confirmButton: "btn btn-primary" },
        buttonsStyling: false,
      });

      setFormData({
        username: "",
        email: "",
        phone_number: "",
        password: "",
        password_confirmation: "",
      });

      navigate("/admin/customer-management"); 
    } catch (err) {
      const errors =
        err.response?.data?.errors ||
        err.response?.data?.message ||
        "Failed to create customer";

      Swal.fire({
        icon: "error",
        title: "Error",
        html:
          typeof errors === "object"
            ? Object.values(errors)
                .flat()
                .map((e) => `<div>${e}</div>`)
                .join("")
            : errors,
        confirmButtonText: "OK",
        customClass: { confirmButton: "btn btn-primary" },
        buttonsStyling: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardWrapper>
      <div className="container-fluid mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <button className="btn btn-secondary" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>

        <div className="card shadow">
          <div className="card-header">
            <h4 className="mb-0">Create Customer</h4>
          </div>

          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label style={{color:"black"}}>Username</label>
                <input
                  type="text"
                  name="username"
                  className="form-control"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label style={{color:"black"}}>Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label style={{color:"black"}}>Phone Number</label>
                <input
                  type="text"
                  name="phone_number"
                  className="form-control"
                  value={formData.phone_number}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Password Field */}
              <div className="mb-3 position-relative">
                <label style={{color:"black"}}>Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-control"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <i
                  className={`bx ${showPassword ? "bx-show" : "bx-hide"} position-absolute`}
                  style={{ right: "10px", top: "32px", cursor: "pointer" }}
                  onClick={() => setShowPassword(!showPassword)}
                ></i>
              </div>

              {/* Confirm Password Field */}
              <div className="mb-3 position-relative">
                <label style={{color:"black"}}>Confirm Password</label>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="password_confirmation"
                  className="form-control"
                  value={formData.password_confirmation}
                  onChange={handleChange}
                  required
                />
                <i
                  className={`bx ${showConfirmPassword ? "bx-show" : "bx-hide"} position-absolute`}
                  style={{ right: "10px", top: "32px", cursor: "pointer" }}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                ></i>
              </div>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Creating..." : "Create Customer"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}
